import React from 'react'
import './styles.scss'
import { Link } from 'gatsby'
import PropTypes from 'prop-types'
import formatDate from '../../../../utilities/FormatDate'

const BlogItem = ({ media, title, date, link, wrapper }) => {
  const content = media ? (
    <a href={link} target="blank" rel="noopener" className="blog-item article">
      <div className="article__wrapper">
        <p className="blog-item__media">{media}</p>
        <p className="blog-item__date">{formatDate(date)}</p>
      </div>
      <p className="blog-item__title">{title}</p>
      <div className="blog-item__arrow" />
    </a>
  ) : (
    <Link className="blog-item" to={link}>
      <p className="blog-item__date">{formatDate(date)}</p>
      <p className="blog-item__title">{title}</p>
      <div className="blog-item__arrow" />
    </Link>
  )
  return (
    <>
      {!wrapper ? (
        content
      ) : (
        <Link className="blog-item" to={link}>
          <p className="blog-item__title">{title}</p>
          <div className="blog-item__arrow" />
        </Link>
      )}
    </>
  )
}

export default BlogItem

BlogItem.propTypes = {
  media: PropTypes.string,
  title: PropTypes.string.isRequired,
  date: PropTypes.string.isRequired,
  link: PropTypes.string.isRequired,
  wrapper: PropTypes.bool,
}

BlogItem.defaultProps = {
  media: null,
  wrapper: false,
}
